import { useState } from "react";
import logo from "../assets/logo.png";
import logo2 from "../assets/logo2.png";
import youtube from "../assets/svgs/youtube.svg";
import Button from "../common/Button";
import Countdown from "react-countdown";
import Info from "./Info";
import { FaBars } from "react-icons/fa6";

const Result = ({ values, score, question, video }) => {
  const [showInfo, setShowInfo] = useState(false);

  const shareHandle = async () => {
    const date = new Date().toDateString();
    const url = `${window.location.href}?utm_source=share`;

    await navigator.share({
      title: "Sporting Cryptic",
      text: `Sporting Cryptic - ${date}\n${question}\nI scored: ${score}\n${url}`,
    });
  };

  return (
    <div className="min-h-screen bg-primary2">
      {showInfo && <Info handleShow={() => setShowInfo(false)} />}
      <div className="bg-white">
        <div className="mx-auto max-w-[630px] px-2 md:px-6 py-1 w-full">
          <div className="flex justify-between items-center">
            <a href="/">
              <img
                src={logo}
                alt="Sporting Cryptic"
                className="size-14 bg-white rounded-full"
              />
            </a>
            <div
              className="size-10 cursor-pointer rounded-full grid place-items-center bg-primary"
              onClick={() => setShowInfo(true)}
            >
              <FaBars
                size={20}
                fill="white"
              />
            </div>
          </div>
          <p className="my-5 text-center">{question}</p>
        </div>
      </div>
      <div className="h-[calc(100%_-_128px)] p-1">
        <div className="mx-auto max-w-[630px] px-1 md:px-6 w-full h-full">
          <div className="flex flex-col">
            <div className="flex items-center justify-center flex-wrap mx-auto py-20 gap-2">
              {values.map((value, index) => (
                <>
                  {value === null ? (
                    <div className="w-full"></div>
                  ) : (
                    <input
                      key={index}
                      type="text"
                      value={value}
                      maxLength="1"
                      className={`size-11 text-2xl text-white lowercase cursor-pointer text-center p-1 font-semibold rounded-md bg-primary shadow-[-4px_4px_0px_0px_black]`}
                      readOnly
                    />
                  )}
                </>
              ))}
            </div>
            <div className="bg-white rounded-lg px-4 py-6 flex flex-col justify-center gap-16 text-center items-center">
              <div>
                <p className="text-2xl font-bold !font-railway">You got it!</p>
                <p className="my-3 !font-railway">You solved the Sporting Cryptic</p>
                <p className="text-2xl font-bold !font-railway">
                  You score: <b>{score}</b>
                </p>
                {score === 10 && <p className="my-3 !font-railway">That's amazing! Well done</p>}
                {score === 0 && (
                  <p className="my-3 !font-railway">Hard luck this time, it was a tough clue</p>
                )}
              </div>
              <div>
                <Button
                  className="flex items-center gap-3 mx-auto"
                  onClick={shareHandle}
                >
                  <img
                    src={logo2}
                    className="bg-white rounded-full size-4"
                    alt=""
                  />
                  Share
                </Button>
                <a
                  href={video}
                  target="_blank"
                  rel="noreferrer"
                  className="mx-auto flex items-center gap-2 my-3 font-semibold w-fit border px-2 p-1 rounded-md"
                >
                  <img
                    src={youtube}
                    className="size-8"
                    alt=""
                  />
                  Explanation
                </a>
                <p className="text-sm italic">
                  Support this project by watching our 90-second explanation. Leave a comment and
                  see what others thought!
                </p>
              </div>
              <p>
                Next clue in{" "}
                <Countdown
                  date={new Date().setHours(23, 59, 59)}
                  renderer={({ hours, minutes, seconds }) => {
                    return (
                      <span className="font-semibold">
                        {hours?.toString()?.padStart(2, 0)}:{minutes?.toString()?.padStart(2, 0)}:
                        {seconds?.toString()?.padStart(2, 0)}
                      </span>
                    );
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Result;
